import axios from "axios";
import { store } from "../../../store";
const api = axios.create({
    //@ts-ignore
    baseURL: BASE_URL,
    timeout: 60000,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});
const getAccessToken = () => {
    const state = store.getState();
    return state?.auth?.userLogin?.response?.data?.accessToken;
};
const getRefreshToken = () => {
    const state = store.getState();
    return state?.auth?.userLogin?.response?.data?.refreshToken;
};
api.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.data instanceof FormData) {
        delete config.headers["Content-Type"];
    }
    else {
        config.headers["Content-Type"] = "application/json";
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});
api.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && error?.request?.responseType !== "blob") {
        originalRequest._retry = true;
        try {
            const refreshToken = getRefreshToken();
            if (refreshToken) {
                const response = await axios.post(
                //@ts-ignore
                `${BASE_URL}/auth/refresh-token`, {
                    refreshToken: refreshToken,
                });
                const { accessToken, refreshToken: newRefreshToken } = response?.data;
                localStorage.setItem("accessToken", accessToken);
                localStorage.setItem("refreshToken", newRefreshToken);
                originalRequest.headers.Authorization = `Bearer ${accessToken}`;
                return api(originalRequest);
            }
        }
        catch (refreshError) {
            //@ts-ignore
            window.location.href = SITE_URL;
        }
    }
    return Promise.reject(error);
});
export default api;
